import { InclusiveAccessBlock, OptInStatus } from '../interface/my-digital-products-aggregated.interface';

export interface PillState {
  label: string;
  /** Open and Closed both render red per Wells's final copy (closed shade TBD). */
  tone: 'positive' | 'negative';
}

/**
 * Pill state from optInStatus only. expiryDate is a formatting input —
 * never compute open/closed from dates client-side.
 */
export function getPillState(
  ia: Pick<InclusiveAccessBlock, 'optInStatus' | 'expiryDate'>,
  formatDate: (iso: string) => string
): PillState {
  if (ia.optInStatus === OptInStatus.CLOSED) {
    return { label: 'Closed', tone: 'negative' };
  }
  if (ia.expiryDate) {
    return { label: `Open until ${formatDate(ia.expiryDate)}`, tone: 'negative' };
  }
  return { label: 'Open', tone: 'negative' };
}

export function isToggleDisabled(ia: Pick<InclusiveAccessBlock, 'optInStatus'>): boolean {
  return ia.optInStatus === OptInStatus.CLOSED;
}

/** MM/DD/YY — pill date (e.g. 12/18/23). */
export function formatShortDate(iso: string): string {
  const d = new Date(iso);
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  const yy = String(d.getUTCFullYear()).slice(-2);
  return `${mm}/${dd}/${yy}`;
}

/** M/D/YYYY — "Last updated" date (e.g. 12/23/2025), no leading zeros. */
export function formatLongDate(iso: string): string {
  const d = new Date(iso);
  return `${d.getUTCMonth() + 1}/${d.getUTCDate()}/${d.getUTCFullYear()}`;
}
